import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_GROUP = "identity-service/access-management/groups";

const RESOURCES = {
	PAGINATED_GROUPS: (page, searchText, clientId, orderBy) =>
		`${BASE_GROUP}/paginated?page=${page}&limit=8` +
		`&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
	LIST_GROUPS: () => `${BASE_GROUP}`,
	GET_GROUP: (id) => `${BASE_GROUP}/${id}`,
	CREATE_GROUP: () => `${BASE_GROUP}`,
	UPDATE_GROUP: (id) => `${BASE_GROUP}/${id}`,
	DELETE_GROUP: (id) => `${BASE_GROUP}/${id}`,
};

class GroupService {
	static async getPaginated(page, searchText, clientId, orderBy) {
		try {
			return await axios.get(
				RESOURCES.PAGINATED_GROUPS(page, searchText, clientId, orderBy),
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar grupos paginados",
			});
			return error.response;
		}
	}

	static async listGroups() {
		try {
			return await axios.get(RESOURCES.LIST_GROUPS());
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao listar grupo",
			});
			return error.response;
		}
	}

	static async getGroup(id) {
		try {
			return await axios.get(RESOURCES.GET_GROUP(id));
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao buscar grupo",
			});
			return error.response;
		}
	}

	static async createGroup(payload) {
		try {
			const response = await axios.post(RESOURCES.CREATE_GROUP(), payload);
			ResponseAlerts({
				response,
				successMessage: "Grupo criada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao criar grupo",
			});
			return error.response;
		}
	}

	static async updateGroup(id, payload) {
		try {
			const response = await axios.put(RESOURCES.UPDATE_GROUP(id), payload);
			ResponseAlerts({
				response,
				successMessage: "Grupo atualizada com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao atualizar grupo",
			});
			return error.response;
		}
	}

	static async deleteGroup(id) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_GROUP(id));
			ResponseAlerts({
				response,
				successMessage: "Grupo removida com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao remover grupo",
			});
			return error.response;
		}
	}
}

export default GroupService;
